<div fxLayout="row" fxLayoutAlign="start start">
  <div fxFlex="32px">
    <mat-icon class="color-orange" nz-tooltip="Requires action">info</mat-icon>
  </div>
  <div fxFlex="calc(100% - 32px)">
    <p
      i18n="@@introductionsView.groupIntroFeedbackPrompt.promptText"
      class="color-grey-300 u-marginBottom-8"
    >
      Did you have a chat with
      {{ account.first_name }}?
    </p>
    <div fxLayout="row" fxLayoutGap="8px">
      <a
        i18n="@@global.yes"
        mat-stroked-button
        color="primary"
        [routerLink]="['/introduction-feedback']"
        [queryParams]="{
          matchId: match._id,
          groupId: group._id,
          outcome: 'have-met',
          source: source
        }"
      >
        Yes
      </a>
      <a
        mat-stroked-button
        [routerLink]="['/introduction-feedback']"
        [queryParams]="{
          matchId: match._id,
          groupId: group._id,
          outcome: 'havent-met',
          source: source
        }"
      >
        <span i18n="@@global.notYet" class="color-grey-300">Not yet</span>
      </a>
    </div>
  </div>
</div>
